import { lazily } from '../utils/helpers';
import { APP_ROUTES, IRoute } from './AppRoutes';
import { USER_ROLES, USER_STATUS } from '../utils/types/user';
import { CreateNewGuest } from '../pages/expert/guests/CreateNewGuest';
import { CreateNewNews } from '../pages/expert/contact-managers/CreateNewNews';
import { CreateEvents } from '../pages/expert/Events/CreateEvents';
import { CreateNewGuestLayout } from '../pages/expert/guests/CreateNewGuestLayout';
import { CreateNewsLayout } from '../pages/expert/contact-managers/CreateNewsLayout';
import { CreateEventsLayout } from '../pages/expert/Events/CreateEventsLoyout';
import { EditNews } from 'src/pages/expert/contact-managers/EditNews';
import { EditEvents } from 'src/pages/expert/Events/EditEvents';

const { EventsListLayout } = lazily(
  () => import('../pages/expert/Events/EventsListLayout'),
);

const { EditEvent } = lazily(() => import('../pages/expert/Events/EditEvent'));

const { JournalistDashboard } = lazily(
  () => import('../pages/journalist/JournalistDashboard'),
);
const { ManagerGuests } = lazily(
  () => import('../pages/expert/profile/ManageGuestProfile/ManagerGuests'),
);
const { TeamMembers } = lazily(
  () => import('../pages/expert/profile/TeamMembers/TeamMembers'),
);

const { AllContacts } = lazily(
  () => import('../pages/journalist/directory/AllContacts'),
);
const { NewContactsLayout } = lazily(
  () => import('../pages/journalist/directory/NewContactsLayout'),
);
const { DirectoryLayout } = lazily(
  () => import('../features/user/journalist/contacts/DirectoryLayout'),
);
const { NewContactCreate } = lazily(
  () => import('../pages/journalist/directory/NewContactCreate'),
);
const { UploadNewContactMedia } = lazily(
  () => import('../pages/journalist/directory/UploadNewContactMedia'),
);

const { UploadCSV } = lazily(
  () => import('../pages/journalist/newsExplorer/DescriptonCSV'),
);
const { NewsExplorer } = lazily(
  () => import('../pages/journalist/newsExplorer/NewsExplorer'),
);

const { ContactDetailsLayout } = lazily(
  () =>
    import('../pages/userCommon/details/contactDetails/ContactDetailsLayout'),
);

const { GeneralInfo } = lazily(
  () => import('../pages/userCommon/details/GeneralInfo'),
);

const { ContactOverviewPage } = lazily(
  () => import('../pages/userCommon/details/ContactOverviewPage'),
);

const { EmailTemplatesAll } = lazily(
  () => import('../pages/journalist/emailTemplates/EmailTemplatesAll'),
);

const { EmailTemplatesNew } = lazily(
  () => import('../pages/journalist/emailTemplates/EmailTemplatesNew'),
);

const { EmailTemplatesEdit } = lazily(
  () => import('../pages/journalist/emailTemplates/EmailTemplatesEdit'),
);

const { JournalistProfileLayout } = lazily(
  () => import('../pages/journalist/profile/JournalistProfileLayout'),
);

const { JournalistPersonalInfo } = lazily(
  () => import('../pages/journalist/profile/JournalistPersonalInfo'),
);

const { JournalistCompany } = lazily(
  () => import('../pages/journalist/profile/JournalistCompany'),
);

const { Security } = lazily(
  () => import('../pages/journalist/profile/Security'),
);

const { ContactDetailsMedia } = lazily(
  () => import('../pages/userCommon/details/ContactDetailsMedia'),
);

const { Test } = lazily(() => import('src/pages/test/Test'));

const { ExpertProfileLayout } = lazily(
  () => import('../pages/expert/profile/ExpertProfileLayout'),
);

const { ExpertPersonalInfo } = lazily(
  () => import('../pages/expert/profile/ExpertPersonalInfo'),
);

const { ExpertCompany } = lazily(
  () => import('../pages/expert/profile/ExpertCompany'),
);

const { Guests } = lazily(() => import('../pages/expert/guests/Guests'));

const { ContactManagers } = lazily(
  () => import('../pages/expert/contact-managers/ContactManagers'),
);

const { Events } = lazily(() => import('../pages/expert/Events/Events'));

// // @ts-ignore
// const { GuestsINFO } = lazily(
//   () => import('../features/user/expert/profile/Guests/Guests'),
// );

const { GuestDetailsLayout } = lazily(
  () => import('../pages/userCommon/details/guestDetails/GuestDetailsLayout'),
);

const { UploadNewGuestsMedia } = lazily(
  () => import('../pages/expert/guests/UploadNewGuestsMedia'),
);

const { AllInterviews } = lazily(
  () => import('../pages/journalist/interviews/AllInterviews'),
);

const { JournalistPlannedInterviews } = lazily(
  () => import('../pages/journalist/interviews/JournalistPlannedInterviews'),
);

const { ProcessInterviews } = lazily(
  () => import('../pages/journalist/interviews/ProcessInterviews'),
);

const { JournalistQuestions } = lazily(
  () => import('../pages/journalist/questions/JournalistQuestions'),
);

const { PendingInterviews } = lazily(
  () => import('../pages/expert/interviews/PendingInterviews'),
);

const { ExpertPlannedInterviews } = lazily(
  () => import('../pages/expert/interviews/ExpertPlannedInterviews'),
);

const { ArchiveInterviews } = lazily(
  () => import('../pages/expert/interviews/ArchiveInterviews'),
);

const { ExpertQuestions } = lazily(
  () => import('../pages/expert/questions/ExpertQuestions'),
);

const { UploadContacts } = lazily(
  () => import('../pages/journalist/directory/UploadContacts'),
);

const { UploadGuests } = lazily(
  () => import('../pages/expert/guests/UploadGuests'),
);

const { ExpertPayment } = lazily(
  () => import('../pages/expert/profile/ExpertPayment'),
);
const { PaymentSucess } = lazily(
	() => import('../pages/expert/profile/PaymentSucess'),
);

const { ResourcesList } = lazily(
  () => import('../pages/journalist/resources/Resources'),
);

const { PitchmarkDashboard } = lazily(() => import('../pages/journalist/resources/pitchmark/PitchmarkLanding'));

const { SendInvite } = lazily(() => import('../pages/journalist/resources/pitchmark/SendInvite/SendInvite'));

const simpleUserStatuses = [USER_STATUS.SIMPLE_USER];
const deletedUserStatuses = [
  USER_STATUS.SIMPLE_USER,
  USER_STATUS.WILL_BE_DELETED,
  USER_STATUS.MUST_PAY,
  USER_STATUS.PAYMENT_IN_PROCESS,
  USER_STATUS.WAIT_FOR_APPROVING,
];

export const userRoutes: Array<IRoute> = [
  {
    path: APP_ROUTES.JOURNALIST_DASHBOARD,
    component: JournalistDashboard,
    roles: [USER_ROLES.JOURNALIST],
    userStatuses: simpleUserStatuses,
  },
  {
    path: APP_ROUTES.JOURNALIST_DASHBOARD_ID(),
    component: JournalistDashboard,
    roles: [USER_ROLES.JOURNALIST],
    userStatuses: simpleUserStatuses,
  },
  {
    path: '/test',
    component: Test,
    roles: [USER_ROLES.JOURNALIST, USER_ROLES.EXPERT],
    userStatuses: simpleUserStatuses,
  },
  {
    path: APP_ROUTES.DIRECTORY,
    component: DirectoryLayout,
    roles: [USER_ROLES.JOURNALIST],
    userStatuses: simpleUserStatuses,
  },
  {
    path: APP_ROUTES.ALL_CONTACTS,
    component: AllContacts,
    roles: [USER_ROLES.JOURNALIST],
    userStatuses: simpleUserStatuses,
  },
  {
    path: APP_ROUTES.UPLOAD_CONTACTS,
    component: UploadContacts,
    roles: [USER_ROLES.JOURNALIST],
    userStatuses: simpleUserStatuses,
  },
  {
    path: APP_ROUTES.CSV_DOWNLOAD,
    component: UploadCSV,
    roles: [USER_ROLES.EXPERT],
    userStatuses: simpleUserStatuses,
  },
  {
    path: APP_ROUTES.NEW_CONTACTS,
    component: NewContactsLayout,
    roles: [USER_ROLES.JOURNALIST],
    exact: false,
    userStatuses: simpleUserStatuses,
    routes: [
      {
        path: APP_ROUTES.CREATE_CONTACT,
        component: NewContactCreate,
      },
      {
        path: APP_ROUTES.FN_UPLOAD_CONTACT_MEDIA(),
        component: UploadNewContactMedia,
        exact: false,
      },
    ],
  },
  // Contact details
  {
    path: APP_ROUTES.FN_CONTACT_DETAILS(),
    component: ContactDetailsLayout,
    roles: [USER_ROLES.JOURNALIST],
    exact: false,
    userStatuses: simpleUserStatuses,
    routes: [
      {
        path: APP_ROUTES.FN_CONTACT_DETAILS_OVERVIEW(),
        component: ContactOverviewPage,
      },
      {
        path: APP_ROUTES.FN_CONTACT_DETAILS_GENERAL(),
        component: GeneralInfo,
      },
      {
        path: APP_ROUTES.FN_CONTACT_DETAILS_MEDIA(),
        component: ContactDetailsMedia,
      },
    ],
  },
  {
    path: APP_ROUTES.EMAIL_TEMPLATES_ALL,
    component: EmailTemplatesAll,
    roles: [USER_ROLES.JOURNALIST],
    userStatuses: simpleUserStatuses,
  },
  {
    path: APP_ROUTES.FN_EMAIL_TEMPLATES_TEMPLATE(),
    component: EmailTemplatesEdit,
    roles: [USER_ROLES.JOURNALIST],
    userStatuses: simpleUserStatuses,
  },
  {
    path: APP_ROUTES.EMAIL_TEMPLATES_NEW,
    component: EmailTemplatesNew,
    roles: [USER_ROLES.JOURNALIST],
    userStatuses: simpleUserStatuses,
  },

  {
    path: APP_ROUTES.JOURNALIST_PROFILE,
    component: JournalistProfileLayout,
    roles: [USER_ROLES.JOURNALIST],
    exact: false,
    userStatuses: deletedUserStatuses,
    routes: [
      {
        path: APP_ROUTES.JOURNALIST_PERSONAL_INFO,
        component: JournalistPersonalInfo,
      },
      {
        path: APP_ROUTES.JOURNALIST_COMPANY,
        component: JournalistCompany,
      },
      {
        path: APP_ROUTES.JOURNALIST_SECURITY,
        component: Security,
      },
    ],
  },
  {
    path: APP_ROUTES.JOURNALIST_ALL_INTERVIEWS,
    component: AllInterviews,
    roles: [USER_ROLES.JOURNALIST],
    userStatuses: simpleUserStatuses,
  },
  {
    path: APP_ROUTES.JOURNALIST_PLANNED_INTERVIEWS,
    component: JournalistPlannedInterviews,
    roles: [USER_ROLES.JOURNALIST],
    userStatuses: simpleUserStatuses,
  },
  {
    path: APP_ROUTES.JOURNALIST_PROCESS_INTERVIEWS,
    component: ProcessInterviews,
    roles: [USER_ROLES.JOURNALIST],
    userStatuses: simpleUserStatuses,
  },
  {
    path: APP_ROUTES.JOURNALIST_QUESTIONS,
    component: JournalistQuestions,
    roles: [USER_ROLES.JOURNALIST],
    userStatuses: simpleUserStatuses,
  },
  // **************************
  // EXPERT`S (MANAGER`S) ROUTES
  {
    path: APP_ROUTES.EXPERT_PROFILE,
    component: ExpertProfileLayout,
    roles: [USER_ROLES.EXPERT],
    exact: false,
    userStatuses: deletedUserStatuses,
    routes: [
      {
        path: APP_ROUTES.EXPERT_PERSONAL_INFO,
        component: ExpertPersonalInfo,
      },
      {
        path: APP_ROUTES.EXPERT_COMPANY,
        component: ExpertCompany,
      },
      {
        path: APP_ROUTES.EXPERT_SECURITY,
        component: Security,
      },
      {
        path: APP_ROUTES.EXPERT_PAYMENT,
        component: ExpertPayment,
      },
      {
        path: APP_ROUTES.EXPERT_GUEST,
        component: ManagerGuests,
      },
      {
        path: APP_ROUTES.TEAM_MEMBERS,
        component: TeamMembers,
      },
    ],
  },
  {
    path: APP_ROUTES.UPLOAD_GUESTS,
    component: UploadGuests,
    roles: [USER_ROLES.EXPERT],
    userStatuses: simpleUserStatuses,
  },
  {
	roles: [USER_ROLES.EXPERT],
	exact: false,
	userStatuses: deletedUserStatuses,
	path: APP_ROUTES.EXPERT_PAYMENT_SUCCESS,
	component: PaymentSucess,
  },
  // New Guest
  {
    path: APP_ROUTES.NEW_GUEST,
    component: CreateNewGuestLayout,
    roles: [USER_ROLES.EXPERT],
    exact: false,
    userStatuses: simpleUserStatuses,
    routes: [
      {
        path: APP_ROUTES.CREATE_GUEST,
        component: CreateNewGuest,
      },
      {
        path: APP_ROUTES.FN_UPLOAD_GUEST_MEDIA(),
        component: UploadNewGuestsMedia,
        exact: false,
      },
    ],
  },
  {
    path: APP_ROUTES.GUESTS,
    component: Guests,
    roles: [USER_ROLES.EXPERT],
    userStatuses: simpleUserStatuses,
  },
  {
    path: APP_ROUTES.NEWS_CONTACTS_MANAGER,
    component: CreateNewsLayout,
    roles: [USER_ROLES.EXPERT],
    exact: false,
    userStatuses: simpleUserStatuses,
    routes: [
      {
        path: APP_ROUTES.CREATE_NEWS_CONTACTS_MANAGER,
        component: CreateNewNews,
      },
      {
        path: APP_ROUTES.FN_EDIT_NEWS_CONTACTS_MANAGER(),
        component: EditNews,
      },
    ],
  },
  {
    path: APP_ROUTES.CREATE_EVENTS,
    component: CreateEventsLayout,
    roles: [USER_ROLES.EXPERT],
    exact: false,
    userStatuses: simpleUserStatuses,
    routes: [
      {
        path: APP_ROUTES.CREATE_EVENTS,
        component: CreateEvents,
      },
      {
        path: APP_ROUTES.FN_EDIT_EVENTS_EVENT(),
        component: EditEvents,
      },
    ],
  },
  {
    path: APP_ROUTES.EVENTS_LIST,
    component: EventsListLayout,
    roles: [USER_ROLES.EXPERT],
    exact: false,
    userStatuses: simpleUserStatuses,
  },
  {
    path: APP_ROUTES.EDIT_EVENT(),
    component: EditEvent,
    roles: [USER_ROLES.EXPERT],
    exact: false,
    userStatuses: simpleUserStatuses,
  },
  {
    path: APP_ROUTES.CONTACTS_MANAGER,
    component: ContactManagers,
    roles: [USER_ROLES.EXPERT],
    userStatuses: simpleUserStatuses,
  },
  {
    path: APP_ROUTES.EVENTS,
    component: Events,
    roles: [USER_ROLES.EXPERT],
    userStatuses: simpleUserStatuses,
  },

  // {
  //   path: APP_ROUTES.GUESTS_INFO,
  //   component: GuestsINFO,
  //   roles: [USER_ROLES.EXPERT],
  //   userStatuses: simpleUserStatuses,
  // },
  // Guest details
  {
    path: APP_ROUTES.FN_GUEST_DETAILS(),
    component: GuestDetailsLayout,
    roles: [USER_ROLES.EXPERT],
    exact: false,
    userStatuses: simpleUserStatuses,
    routes: [
      {
        path: APP_ROUTES.FN_GUEST_DETAILS_OVERVIEW(),
        component: ContactOverviewPage,
      },
      {
        path: APP_ROUTES.FN_GUEST_DETAILS_GENERAL(),
        component: GeneralInfo,
      },
      {
        path: APP_ROUTES.FN_GUEST_DETAILS_MEDIA(),
        component: ContactDetailsMedia,
      },
    ],
  },
  {
    path: APP_ROUTES.EXPERT_PENDING_INTERVIEWS,
    component: PendingInterviews,
    roles: [USER_ROLES.EXPERT],
    userStatuses: simpleUserStatuses,
  },
  {
    path: APP_ROUTES.EXPERT_PLANNED_INTERVIEWS,
    component: ExpertPlannedInterviews,
    roles: [USER_ROLES.EXPERT],
    userStatuses: simpleUserStatuses,
  },
  {
    path: APP_ROUTES.EXPERT_ARCHIVE_INTERVIEWS,
    component: ArchiveInterviews,
    roles: [USER_ROLES.EXPERT],
    userStatuses: simpleUserStatuses,
  },
  {
    path: APP_ROUTES.EXPERT_QUESTIONS,
    component: ExpertQuestions,
    roles: [USER_ROLES.EXPERT],
    userStatuses: simpleUserStatuses,
  },
  {
    path: APP_ROUTES.JOURNALIST_RESOURCES,
    component: ResourcesList,
    roles: [USER_ROLES.JOURNALIST],
    userStatuses: simpleUserStatuses,
  },
  {
    path: APP_ROUTES.JOURNALIST_RESOURCES_PITCHMARK,
    component: PitchmarkDashboard,
    roles: [USER_ROLES.JOURNALIST],
    userStatuses: simpleUserStatuses, 
  },
  {
    path: APP_ROUTES.PITCHMARK_SENDOFFER,
    component: SendInvite,
	roles: [USER_ROLES.JOURNALIST],
    userStatuses: simpleUserStatuses, 
  },
];
